import moment from 'moment-timezone';

export class TimezoneHelper {

    private static readonly TIMEZONE_NAME = 'Europe/Warsaw';

    static convertUTCToLocal(utcDate: Date | string): Date | null {
        if (!utcDate) {
            return null;
        }

        const localMoment = moment.utc(utcDate).tz(this.TIMEZONE_NAME);

        return localMoment.toDate();
    }

    static createMidnightInLocalAsUTC(date: Date | moment.Moment): Date | null {
        if (!date) {
            return null;
        }

        let year: number, month: number, day: number;

        if (moment.isMoment(date)) {
            year = date.year();
            month = date.month();
            day = date.date();
        } else {
            const d = new Date(date);
            year = d.getFullYear();
            month = d.getMonth();
            day = d.getDate();
        }

        const localMoment = moment.tz({
            year,
            month,
            day,
            hour: 0,
            minute: 0,
            second: 0,
            millisecond: 0
        }, this.TIMEZONE_NAME);

        return localMoment.utc().toDate();
    }

    static createDateTimeInLocalAsUTC(
        date: Date | moment.Moment,
        time: string): Date | null {
        if (!date) {
            return null;
        }

        let year: number, month: number, day: number;

        if (moment.isMoment(date)) {
            year = date.year();
            month = date.month();
            day = date.date();
        } else {
            const d = new Date(date);
            year = d.getFullYear();
            month = d.getMonth();
            day = d.getDate();
        }

        let hours = 0, minutes = 0;
        if (time) {
            const timeArr = time.split(':').map(t => parseInt(t, 10));
            hours = timeArr[0] || 0;
            minutes = timeArr[1] || 0;
        }

        const localMoment = moment.tz({
            year,
            month,
            day,
            hour: hours,
            minute: minutes,
            second: 0,
            millisecond: 0
        }, this.TIMEZONE_NAME);

        return localMoment.utc().toDate();
    }

    static createDateTimeInLocalWithTimezone(
        date: Date | moment.Moment,
        time: string): string | null {
        if (!date) {
            return null;
        }

        let year: number, month: number, day: number;

        if (moment.isMoment(date)) {
            year = date.year();
            month = date.month();
            day = date.date();
        } else {
            const d = new Date(date);
            year = d.getFullYear();
            month = d.getMonth();
            day = d.getDate();
        }

        let hours = 0, minutes = 0;
        if (time) {
            const timeArr = time.split(':').map(t => parseInt(t, 10));
            hours = timeArr[0] || 0;
            minutes = timeArr[1] || 0;
        }

        const localMoment = moment.tz({
            year,
            month,
            day,
            hour: hours,
            minute: minutes,
            second: 0,
            millisecond: 0
        }, this.getUserTimezone());

        return localMoment.format();
    }

    static formatUTCDateInLocal(
        utcDate: Date | string,
        format: string = 'YYYY-MM-DD HH:mm'): string {
        if (!utcDate) {
            return '';
        }

        const localMoment = this.convertUTCToLocalMoment(utcDate);
        return localMoment ? localMoment.format(format) : '';
    }

    static getCurrentTimezone(): string {
      return this.TIMEZONE_NAME;
    }

    static getUserTimezone(): string {
      return Intl.DateTimeFormat().resolvedOptions().timeZone;
    }

    private static convertUTCToLocalMoment(utcDate: Date | string): moment.Moment | null {
        if (!utcDate) {
            return null;
        }

        return moment.utc(utcDate).tz(this.TIMEZONE_NAME);
    }
}
